import { render, staticRenderFns } from "./FollowUpConversion.vue?vue&type=template&id=6fc1ae87&"
import script from "./FollowUpConversion.vue?vue&type=script&lang=js&"
export * from "./FollowUpConversion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports